import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'

// Disable react-beautiful-dnd dev warnings
;(window as any)['__react-beautiful-dnd-disable-dev-warnings'] = true

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<App />)
